import { render, staticRenderFns } from "./GoogleCallback.vue?vue&type=template&id=60d97df6"
import script from "./GoogleCallback.vue?vue&type=script&lang=js"
export * from "./GoogleCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports